import { point, distance } from '@turf/turf';
import api from '../../Services/Api';

export const DEPARTMENT_CODES = {
  Nord: 59,
};

export const NORD_ZONES = {
  start: {
    bbox: [2.05, 49.9, 4.35, 51.12],
    proximity: [3.057256, 50.62925], // Lille
    polygon: [
      [
        [51.1, 2.25],
        [51.05, 3.25],
        [50.78, 4.2],
        [50.2, 4.35],
        [49.92, 4.2],
        [49.92, 3.4],
        [50.05, 3.05],
        [50.35, 2.7],
        [50.65, 2.5],
        [50.95, 2.3],
        [51.1, 2.25],
      ],
    ],
  },
  end: {
    bbox: [-1.5, 42.5, 8.3, 51.6],
    proximity: [3.057256, 50.62925],
    polygon: [
      [
        [51.6, -1.5],
        [51.6, 8.3],
        [42.5, 8.3],
        [42.5, -1.5],
        [51.6, -1.5],
      ],
    ],
  },
};

export const askTransport = (
  addressFrom,
  addressTo,
  transportDate,
  transportTime,
  upsertForm,
  showToaster,
  onHistoryPush,
) => {
  api
    .getCities(addressFrom.locality, Object.values(DEPARTMENT_CODES))
    .then(resp => {
      const cities = resp?.data?.cities || [];
      const km = distance(
        point([addressFrom.latitude, addressFrom.longitude]),
        point([addressTo.latitude, addressTo.longitude]),
        { units: 'kilometers' },
      );
      upsertForm({ addressFrom, addressTo, transportDate, transportTime, distance: km });

      if (cities.length > 0) {
        onHistoryPush(cities[0].slug);
      } else {
        showToaster();
      }
    })
    .catch(() => showToaster());
};
